import { render, staticRenderFns } from "./RateAsideSettings.vue?vue&type=template&id=1115bf5b&"
import script from "./RateAsideSettings.vue?vue&type=script&lang=ts&"
export * from "./RateAsideSettings.vue?vue&type=script&lang=ts&"
import style0 from "./RateAsideSettings.vue?vue&type=style&index=0&id=1115bf5b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports